export default "__VITE_ASSET__f59f4aa8__"